const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export async function getInstitutions() {
  try {
    console.log('[institutions.js] Llamando a:', `${API_BASE}/catalogos/instituciones/`);
    const res = await fetch(`${API_BASE}/catalogos/instituciones/`, {
      headers: getAuthHeaders()
    });
    console.log('[institutions.js] Status:', res.status);
    if (!res.ok) {
      console.error('[institutions.js] Error en respuesta:', res.status, res.statusText);
      return [];
    }
    const data = await res.json();
    console.log('[institutions.js] Datos recibidos:', data);
    console.log('[institutions.js] Total instituciones:', data.length);
    
    if (Array.isArray(data) && data.length > 0) {
      const mapped = data.map(inst => ({
        id: inst.id_institucion || inst.id,
        name: inst.nombre_institucion || inst.name,
        clave: inst.clave_institucion,
        telefono: inst.telefono,
        email: inst.email,
        direccion: inst.direccion,
        estado: inst.activo ? 'ACTIVO' : 'INACTIVO',
        logo: inst.logotipo_url || '',
      }));
      console.log('[institutions.js] Instituciones mapeadas:', mapped);
      return mapped;
    }
    console.warn('[institutions.js] No hay instituciones en la respuesta');
    return [];
  } catch (err) {
    console.error('[institutions.js] Error al cargar instituciones:', err);
    return [];
  }
}

export async function createInstitution(form) {
  const payload = {
    nombre_institucion: form.nombre,
    clave_institucion: form.clave,
    telefono: form.telefono,
    email: form.email,
    direccion: form.direccion,
    activo: form.estado === 'ACTIVO',
    logotipo_url: form.logo ? form.logo : '',
  };
  const res = await fetch(`${API_BASE}/catalogos/instituciones/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al crear institución');
  return await res.json();
}

export async function updateInstitution(id, form) {
  const payload = {
    nombre_institucion: form.nombre,
    clave_institucion: form.clave,
    telefono: form.telefono,
    email: form.email,
    direccion: form.direccion,
    activo: form.estado === 'ACTIVO',
    logotipo_url: form.logo ? form.logo : '',
  };
  const res = await fetch(`${API_BASE}/catalogos/instituciones/${id}/`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('Error al actualizar institución');
  return await res.json();
}

export async function deleteInstitution(id) {
  const res = await fetch(`${API_BASE}/catalogos/instituciones/${id}/`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!res.ok) throw new Error('Error al eliminar institución');
  return true;
}
